/**
 * Lamination 2's extruder dashboard — the shared one, on `/lam2`.
 *
 * See `components/common/LamExtruderDashboard`: Line 1 and Line 2 run the same
 * PLC program behind the same endpoints, so they share the dashboard and differ
 * only in which line's calls they hand it.
 */
import React from "react";
import LamExtruderDashboard from "../../common/LamExtruderDashboard";
import { lam2Api } from "../../../api/lam2";

const Lam2ExtruderDashboard: React.FC = () => (
  <LamExtruderDashboard api={lam2Api} prefsKey="lam2" />
);

export default Lam2ExtruderDashboard;
